import { useState } from "react";
import wellDoneIcon from "../../../assets/images/well-done-icon.svg";
import "./Statistics.scss";

import invalidIcon from "../../../assets/images/invalid-icon.svg";
import tryAgainIcon from "../../../assets/images/thumbUp-icon.svg";

const answerData = [
  {
    label: "A",
    count: 5,
    students: ["Student 2", "Student 3", "Student 4", "Student 5"],
    className: "red-answer",
    width: "60px",
    correct: false,
  },
  {
    label: "B",
    count: 10,
    students: [
      "Student 1",
      "Student 6",
      "Student 7",
      "Student 8",
      "Student 9",
      "Student 10",
      "Student 11",
      "Student 24",
      "Student 13",
      "Student 15",
      "Student 19",
      "Student 20",
    ],
    className: "green-answer",
    width: "120px",
    correct: true,
  },
  {
    label: "C",
    count: 5,
    students: ["Student 2", "Student 3", "Student 4", "Student 5"],
    width: "60px",
    correct: false,
    type: "ai",
    aiStatus: "well-done",
  },

  {
    label: "D",
    count: 0,
    students: [],
    className: "disabled-answer red-answer",
    width: "120px",
  },
  {
    label: "E",
    count: 10,
    students: [
      "Student 1",
      "Student 6",
      "Student 7",
      "Student 8",
      "Student 9",
      "Student 10",
      "Student 11",
      "Student 24",
      "Student 13",
      "Student 15",
      "Student 19",
      "Student 20",
    ],
    width: "150px",
  },
];

const remainingStudents = [
  "Student 21",
  "Student 22",
  "Student 23",
  "Student 25",
  "Student 26",
];

const Statistics = () => {
  const [openIndex, setOpenIndex] = useState(0); //
  const [showRemaining, setShowRemaining] = useState(false);

  const handleAccordion = (idx: number) => {
    if (openIndex === idx) {
      setOpenIndex(-1); // Close if already open
    } else {
      setOpenIndex(idx); // Open the clicked one
      setShowRemaining(false);
    }
  };
  const handleRemainingAccordion = () => {
    setShowRemaining((prev) => !prev);
    setOpenIndex(-1);
  };

  return (
    <div className="statistics-container">
      <div className="statistics-block">
        <ul className="statistics statistics-puzzle">
          {answerData.map((item, idx) => {
            const liClasses = ["statistics-item", item.className]
              .filter(Boolean)
              .join(" ");
            const onlyStatisticsItem = liClasses.trim() === "statistics-item";
            return (
              <li className={liClasses} key={idx}>
                <div className="statistics-header">
                  <div className="choice">{item.label}</div>
                  <div className="total-statistics">
                    <div className="total-responsive">
                      <span className="student-count">{item.count}</span>
                      Students
                    </div>
                    <div
                      className="total-persentage"
                      style={{ width: item.width }}
                    ></div>

                    {item.type === "ai" ? (
                      <span className="icon-status">
                        {item.aiStatus === "good-try" && (
                          <img src={tryAgainIcon} alt="" />
                        )}
                        {item.aiStatus === "invalid" && (
                          <img src={invalidIcon} alt="" />
                        )}
                        {item.aiStatus === "well-done" && (
                          <img src={wellDoneIcon} alt="" />
                        )}
                      </span>
                    ) : (
                      !onlyStatisticsItem && (
                        <span className="icon-status">
                          {item.correct ? (
                            <span>
                              <i className="f-icon check-icon"></i>
                            </span>
                          ) : (
                            <span>
                              <i className="f-icon times-icon"></i>
                            </span>
                          )}
                        </span>
                      )
                    )}
                  </div>
                  <button
                    className="accordion-toggle"
                    onClick={() => handleAccordion(idx)}
                    aria-label={openIndex === idx ? "Collapse" : "Expand"}
                  >
                    {openIndex === idx ? (
                      <i className="f-icon chevron-up-icon"></i>
                    ) : (
                      <i className="f-icon chevron-down-icon"></i>
                    )}
                  </button>
                </div>
                {openIndex === idx && (
                  <div className="students-list">
                    {item.students.map((student, i) => (
                      <div className="student-item" key={i}>
                        {student}
                      </div>
                    ))}
                  </div>
                )}
              </li>
            );
          })}
          {/* Remaining Students Accordion */}
          <li className="remaining-students">
            <div className="statistics-header">
              <div className="total-statistics">
                <div className="total-responsive">
                  <span className="student-count">
                    {remainingStudents.length}
                  </span>
                  Remaining Students
                </div>
                <div
                  className="total-persentage"
                  style={{ width: "60px" }}
                ></div>
              </div>

              <button
                className="accordion-toggle"
                onClick={handleRemainingAccordion}
                aria-label={showRemaining ? "Collapse" : "Expand"}
              >
                {showRemaining ? (
                  <i className="f-icon chevron-up-icon"></i>
                ) : (
                  <i className="f-icon chevron-down-icon"></i>
                )}
              </button>
            </div>
            {showRemaining && (
              <div className="students-list">
                {remainingStudents.map((student, i) => (
                  <div className="student-item" key={i}>
                    {student}
                  </div>
                ))}
              </div>
            )}
          </li>
        </ul>
      </div>
      <div className="statistics--action">
        <button className="btn-primary btn">Time's Up</button>
      </div>
    </div>
  );
};

export default Statistics;
